export default __webpack_public_path__ + "static/media/P800_B_BD.c4a3ca87.pdf";